export default __webpack_public_path__ + "b36c0cc.png";